module.exports = __webpack_public_path__ + "static/media/green2.0251f8fc.jpg";